var _rect, _path, _rect2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJAngKIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 24,
    viewBox: "0 0 52 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 24,
    height: 24,
    rx: 3,
    fill: "#1A1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8335 16V8.72727H38.151V12.0689H38.2398L41.0771 8.72727H42.6858L39.8733 11.9908L42.7107 16H41.1269L38.9571 12.8821L38.151 13.8338V16H36.8335Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7839 8.72727H14.0907V13.8409C14.0884 14.3097 13.9889 14.7133 13.7924 15.0518C13.5959 15.388 13.3213 15.6473 12.9686 15.8295C12.6182 16.0095 12.2098 16.0994 11.7434 16.0994C11.3173 16.0994 10.9338 16.0237 10.5929 15.8722C10.2543 15.7183 9.98562 15.491 9.78675 15.1903C9.58789 14.8897 9.48846 14.5156 9.48846 14.0682H10.7988C10.8012 14.2647 10.8438 14.4339 10.9267 14.576C11.0119 14.718 11.1291 14.8269 11.2782 14.9027C11.4274 14.9785 11.599 15.0163 11.7931 15.0163C12.0038 15.0163 12.1826 14.9725 12.3294 14.8849C12.4761 14.795 12.5874 14.6624 12.6632 14.4872C12.7413 14.312 12.7815 14.0966 12.7839 13.8409V8.72727Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJAngKIcons);
export default __webpack_public_path__ + "static/media/JAngKIcons.5cf100808e72763be188273c691cb3ca.svg";
export { ForwardRef as ReactComponent };